export default __webpack_public_path__ + "images/49a96f64ef3920b5500cbd3955ec20d3-newyearseve.webp";